import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/App.vue'),
      children: [
        {
          path: '',
          name: 'home',
          component: () => import('@/pages/lp/org.vue')
        },
        {
          path: '/news-list',
          name: 'news-list',
          component: () => import('@/pages/newsList.vue')
        },
        {
          path: '/news-detail/:tid',
          name: 'news-detail',
          component: () => import('@/pages/newsDetail.vue')
        },
        {
          path: '/home-weixin',
          name: 'home-weixin',
          component: () => import('@/pages/wxtg.vue')
        },
        {
          path: '/august-activity',
          name: 'august-activity',
          component: () => import('@/pages/augustActivity.vue')
        },
        {
          path: '/xiaoxue',
          name: 'xiaoxue',
          component: () => import('@/pages/primaryLesson.vue')
        },
        {
          path: '/lp/sem',
          name: 'org-sem',
          component: () => import('@/pages/lp/orgSem2.vue')
        },
        {
          path: '/lp/sem-test',
          name: 'org-sem-test',
          component: () => import('@/pages/lp/orgSem2.vue')
        },
        {
          path: '/greet-card',
          name: 'greet-card',
          component: () => import('@/pages/greetCard.vue')
        },
        {
          path: '/activity',
          name: 'activity',
          component: () => import('@/pages/activity.vue')
        },
        {
          path: '/appointment-success',
          name: 'appointment-success',
          component: () => import('@/pages/appointment-success.vue')
        },
        {
          path: '/appointment-success2',
          name: 'appointment-success2',
          component: () => import('@/pages/appointment-success2.vue')
        },
        {
          path: '/appointment-success4',
          name: 'appointment-success4',
          component: () => import('@/pages/appointment-success4.vue')
        },
        {
          path: '/appointment-success5',
          name: 'appointment-success5',
          component: () => import('@/pages/appointment-success5.vue')
        },
        {
          path: '/appointment-success7',
          name: 'appointment-success7',
          component: () => import('@/pages/appointment-success7.vue')
        },
        {
          path: '/appointment-unadmission',
          name: 'appointment-unadmission',
          component: () => import('@/pages/appointment-unadmission.vue')
        },
        {
          path: '/augustActivity',
          name: 'augustActivity',
          component: () => import('@/pages/augustActivity.vue')
        },
        {
          path: '/error',
          name: 'error',
          component: () => import('@/pages/error.vue')
        },
        {
          path: '/greetCard',
          name: 'greetCard',
          component: () => import('@/pages/greetCard.vue')
        },
        {
          path: '/newsDetail',
          name: 'newsDetail',
          component: () => import('@/pages/newsDetail.vue')
        },
        {
          path: '/newsList',
          name: 'newsList',
          component: () => import('@/pages/newsList.vue')
        },
        {
          path: '/primaryLesson',
          name: 'primaryLesson',
          component: () => import('@/pages/primaryLesson.vue')
        },
        {
          path: '/wxtg',
          name: 'wxtg',
          component: () => import('@/pages/wxtg.vue')
        },
        {
          path: '/lp/activity',
          name: 'lp-activity',
          component: () => import('@/pages/lp/activity.vue')
        },
        {
          path: '/lp/dsp',
          name: 'lp-dsp',
          component: () => import('@/pages/lp/dsp.vue')
        },
        {
          path: '/lp/feed',
          name: 'lp-feed',
          component: () => import('@/pages/lp/feed.vue')
        },
        {
          path: '/lp/math',
          name: 'lp-math',
          component: () => import('@/pages/lp/math.vue')
        },
        {
          path: '/lp/nm',
          name: 'lp-nm',
          component: () => import('@/pages/lp/nm.vue')
        },
        {
          path: '/lp/nmtest',
          name: 'lp-nmtest',
          component: () => import('@/pages/lp/nmtest.vue')
        },
        {
          path: '/lp/org',
          name: 'lp-org',
          component: () => import('@/pages/lp/org.vue')
        },
        {
          path: '/lp/orgSem',
          name: 'lp-orgSem',
          component: () => import('@/pages/lp/orgSem.vue')
        },
        {
          path: '/lp/orgSem2',
          name: 'lp-orgSem2',
          component: () => import('@/pages/lp/orgSem2.vue')
        },
        {
          path: '/lp/sprint',
          name: 'lp-sprint',
          component: () => import('@/pages/lp/sprint.vue')
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/pages/404.vue')
    }
  ]
})

export default router
